import { render, staticRenderFns } from "./workerWageList.vue?vue&type=template&id=0fb946fa&scoped=true&"
import script from "./workerWageList.vue?vue&type=script&lang=js&"
export * from "./workerWageList.vue?vue&type=script&lang=js&"
import style0 from "./workerWageList.vue?vue&type=style&index=0&id=0fb946fa&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fb946fa",
  null
  
)

export default component.exports